import {
  ORDER_STATUS_ACCEPTED,
  ORDER_STATUS_CANCELED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_CREATED,
  ORDER_STATUS_DELIVERED,
  ORDER_STATUS_DRAFT,
  ORDER_STATUS_IN_PROGRESS,
  ORDER_STATUS_NEW,
  ORDER_STATUS_PACKED,
  ORDER_STATUS_PAID,
} from "constants/OrderConstant";
import {
  USER_STATUS_ACTIVE,
  USER_STATUS_INVITED,
  USER_STATUS_PENDING,
  USER_STATUS_REJECTED,
} from "constants/UserConstant";
import i18n from "translations/i18n";
import { ORDER_STATUS_CANCELLED } from "../constants/OrderConstant";

export const formatPrice = function (value) {
  const numericValue = parseFloat(value);
  if (!!numericValue) {
    return numericValue.toLocaleString("nl-NL", {
      minimumFractionDigits: numericValue % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
  } else return 0;
};

export const getPaymentStatus = (status) => {
  if (status === ORDER_STATUS_PAID) return i18n.t("order.status_paid");
  else if (status === ORDER_STATUS_IN_PROGRESS) return i18n.t("order.status_shipped");
  else if (status === ORDER_STATUS_DELIVERED) return i18n.t("order.status_delivered");
  else if (status === ORDER_STATUS_PACKED) return i18n.t("order.status_packed");
  else if (status === ORDER_STATUS_CONFIRMED) return i18n.t("order.status_confirmed");
  else if (status === ORDER_STATUS_ACCEPTED) return i18n.t("order.status_confirmed");
  else if (status === ORDER_STATUS_CANCELED) return i18n.t("order.status_canceled");
  else if (status === ORDER_STATUS_CANCELLED) return i18n.t("order.status_canceled");
  else if (status === ORDER_STATUS_NEW) return i18n.t("order.status_new");
  else if (status === ORDER_STATUS_CREATED) return i18n.t("order.status_created");
  else if (status === ORDER_STATUS_DRAFT) return i18n.t("order.status_draft");
  else if (status === ORDER_STATUS_DRAFT) return i18n.t("order.status_shipped");
};

export const getUserStatus = (status) => {
  if (status === USER_STATUS_PENDING) return i18n.t("customer.status_pending");
  else if (status === USER_STATUS_REJECTED) return i18n.t("customer.status_banned");
  else if (status === USER_STATUS_ACTIVE) return i18n.t("customer.status_active");
  else if (status === USER_STATUS_INVITED) return i18n.t("customer.status_invited");
  else return i18n.t(status);
};

export const formatNameToURL = (name) => {
  name = name.replace(/^\s+|\s+$/g, "");
  name = name.toLowerCase();

  // remove accents, swap ñ for n, etc
  let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  let to = "aaaaeeeeiiiioooouuuunc------";
  for (let i = 0, l = from.length; i < l; i++) {
    name = name.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  // remove invalid chars
  // collapse whitespace and replace by -
  // collapse dashes
  name = name
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

  return name;
};

export const formatInvoiceFileName = (invoice, orderId) => {
  return invoice + "-" + orderId + ".pdf";
};

export const getTelephoneCountryCode = (digit) => {
  switch (digit) {
    case "6":
      return "+31"; // NL
    case "4":
      return "+32"; // BE
    case "7":
      return "+33"; // FR
    case "1":
      return "+49"; // DE
    default:
      return "+31";
  }
};

export const formatPhoneNumber = (phoneNumber) => {
  // Verwijder alle niet-numerieke tekens behalve +
  let cleaned = ("" + phoneNumber).replace(/[^\d+]/g, "");

  // Controleer of het landnummer begint met '00' en vervang met '+'
  if (cleaned.startsWith("00")) {
    cleaned = "+" + cleaned.slice(2);
  }

  // Als het nummer al een + heeft, return as-is
  if (cleaned.startsWith("+")) {
    return cleaned;
  }

  // Check for country codes (NL, BE, FR, DE, etc.) - add + prefix
  if (cleaned.startsWith("31") || cleaned.startsWith("32") || cleaned.startsWith("33") || cleaned.startsWith("49")) {
    // Remove leading 0 after country code if present
    if (cleaned[2] === "0") {
      return "+" + cleaned.slice(0, 2) + cleaned.slice(3);
    } else {
      return "+" + cleaned;
    }
  }

  // No country code detected - return cleaned number as-is (no auto-adding)
  return cleaned;
};

// Helper function to format weight in grams
// < 1000g -> shows in grams (e.g., "500 g")
// >= 1000g -> shows in kg (e.g., "2.5 kg")
export const formatWeight = (grams) => {
  if (!grams || grams === 0) return "0 g";

  if (grams < 1000) {
    return `${grams} g`;
  }

  const kg = grams / 1000;
  return `${kg.toFixed(2)} kg`.replace(/\.00$/, ""); // Remove .00 if whole number
};
